import ChatSupportSvg from "../../Icons/ChatSupportSvg";
import FAQSvg from "../../Icons/FAQSvg";
import BlogSvg from "../../Icons/BlogSvg";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  CenteredGridWithHeading,
} from "@reusejs/react";
import SectionHeading from "../SectionHeading";
import Link from "next/link";

let helpSectionDetails = {
  title: "Need help?",
};

const Icon = (props: any) => {
  return (
    <div className="p-4 md:p-5 rounded-xl bg-blue-100">{props.iconObject}</div>
  );
};

const Actions = (props: any) => {
  return (
    <Link href={props.link}>
      <a className="text-blue-600 cursor-pointer">
        {props.link === "/contactus" ? "Chat Now >" : "Learn More >"}
      </a>
    </Link>
  );
};

const items = [
  {
    title: "24/7 Chat Support",
    description:
      "Chat support with our friendly customer service agents at your service.",
    icon: <Icon iconObject={<ChatSupportSvg />} />,
    actions: <Actions link={"/contactus"} />,
  },
  {
    title: "FAQs",
    description: "View FAQs for detailed instructions on specific features.",
    icon: <Icon iconObject={<FAQSvg />} />,
    actions: <Actions link={"/faq"} />,
  },
  {
    title: "Blogs",
    description: "Stay up to date with the latest stories and commentary.",
    icon: <Icon iconObject={<BlogSvg />} />,
    actions: <Actions link={"#"} />,
  },
];

const ItemRendererComponent = (props?: any) => {
  return (
    <>
      {props.items.map((item?: any, index?: number) => {
        return (
          <IconTitleDescriptionActionCard
            key={index}
            title={item.title}
            icon={item.icon}
            description={item.description}
            iconPosition="left"
            actions={item.actions}
            itemTitleDescriptionCardBaseClasses={{
              iconWrapper:
                "flex h-12 w-12 items-center justify-center rounded-md text-white",
              titleWrapper: "mt-2 text-left",
              titleStyles: "text-xl font-bold text-gray-900",
              descriptionWrapper: "text-left mt-2",
              descriptionStyles: "text-base text-gray-500",
              actionWrapper: "mt-2 text-left",
            }}
          />
        );
      })}
    </>
  );
};

export default function HelpComponent() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-10 md:py-20",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
      }}
    >
      <CenteredGridWithHeading
        headingSection={
          <SectionHeading
            title={helpSectionDetails.title}
            itemTitleDescriptionCardBaseClasses={{
              wrapper: "mb-10",
              titleWrapper: "text-left",
              titleStyles: "text-2xl md:text-3xl font-extrabold",
            }}
          />
        }
        sectionContentData={items}
        itemsRenderer={ItemRendererComponent}
        centeredGridBaseClasses={{
          gridClasses:
            "grid sm:grid-cols-2 md:grid-cols-3 gap-y-10 md:gap-y-4 gap-x-8  md:space-y-0",
        }}
      />
    </SectionContainerBase>
  );
}
